import React from "react";
import { useApp } from "@/context/AppContext";
import { BadgeCheck } from "lucide-react";

export const VerifiedBadge = ({ className = "" }) => {
  const { t } = useApp();
  return (
    <span
      data-testid="verified-badge"
      className={`inline-flex items-center gap-1 rounded-full bg-primary/10 px-2 py-0.5 text-xs font-semibold text-primary ${className}`}
    >
      <BadgeCheck className="h-3.5 w-3.5" /> {t("badge.verified")}
    </span>
  );
};
